import { Store } from 'pullstate';
import * as XLSX from 'xlsx';
import { ImportRowSchema, SheetError } from '../../../../../features/data-management/leads/ExcelImportStore';
import { Account } from '../../../../../stores/AccountStore';

export const accountImportSchema = [
    {
        displayName: 'Account Name',
        columnName: 'accountName',
        dataType: 'string',
        maxLength: 255,
        isSelect: false,
        required: true,
    },
    //{
    //    displayName: 'HQ Address',
    //    columnName: 'hqAddress',
    //    dataType: 'string',
    //    maxLength: 255,
    //    isSelect: false,
    //    required: false,
    //},
    //{
    //    displayName: 'HQ Province',
    //    columnName: 'hqProvince',
    //    dataType: 'string',
    //    maxLength: 255,
    //    isSelect: false,
    //    required: false,
    //},
    //{
    //    displayName: 'HQ Postal Code',
    //    columnName: 'hqPostalCode',
    //    dataType: 'string',
    //    maxLength: 255,
    //    isSelect: false,
    //    required: false,
    //},
    {
        displayName: 'HQ Country',
        columnName: 'hqCountry',
        dataType: 'string',
        maxLength: 255,
        isSelect: false,
        required: false,
    },
    {
        displayName: 'Industry',
        columnName: 'leadIndustry',
        dataType: 'string',
        maxLength: 2000,
        isSelect: true,
        required: false,
    },
    {
        displayName: 'Region',
        columnName: 'leadRegion',
        dataType: 'string',
        maxLength: 2000,
        isSelect: true,
        required: false,
    },
    //{
    //    displayName: 'Company Revenue',
    //    columnName: 'leadCompanyRevenue',
    //    dataType: 'string',
    //    maxLength: 2000,
    //    isSelect: true,
    //},
] as ImportRowSchema[];

const AccountImportStore = new Store({
    open: false,
    workbook: null as null | XLSX.WorkBook,
    revalidate: false,
    worksheet: null as null | XLSX.WorkSheet,
    errors: [] as SheetError[],
    unmappedColumns: [] as string[],
    mapSchema: [] as ImportRowSchema[],
    loaded: false,
    fileError: false,
    hasUnmappedRequired: false,
    currentStep: 1,
    allColumns: [] as string[],
    accounts: [] as Account[],
});

export default AccountImportStore;
